import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import DueDatePage from './component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { acceptTerms, savePaymentSettings } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import paths from '@rental-manager/pathsManifest';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { paymentSettings, leasesForProperty, leaseId } = state.payments.landlord.onboarding[propertyId];
  const { editPaymentDayOfTheMonth, editDayOfTheMonth, editMode } = paymentSettings;
  let { paymentDayOfTheMonth } = paymentSettings;
  const { startDate: startDateFromLease } = leasesForProperty[leaseId] || {};

  if (!editPaymentDayOfTheMonth && startDateFromLease) {
    paymentDayOfTheMonth = new Date(startDateFromLease).getUTCDate();
  }

  return {
    editDayOfTheMonth,
    paymentDayOfTheMonth,
    editMode,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId, fromDashboard }) => ({
  onSubmit: (paymentSettings) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(acceptTerms({ propertyId })))
      .then(() => dispatch(savePaymentSettings({ propertyId, paymentSettings })))
      .then(() => dispatch(push(baseUrl + paths.onboarding.termLengthPage)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onSubmitFromDashboard: (paymentSettings) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(savePaymentSettings({ propertyId, paymentSettings })))
      .then(() =>
        dispatch(push(baseUrl + paths.dashboard.editTermLengthPage, { fromWhere: paths.dashboard.editDueDatePage })),
      )
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: (paymentSettings) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(savePaymentSettings({ propertyId, paymentSettings })))
      .then(() => dispatch(goBack())),
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => {
        const paymentSettings = {
          editDayOfTheMonth: null,
        };

        return dispatch(savePaymentSettings({ propertyId, paymentSettings }));
      })
      .then(() => {
        const newUrl = fromDashboard ? baseUrl : baseUrl + paths.onboarding.confirmationPage;
        return dispatch(push(newUrl));
      }),
  onClose: (paymentSettings) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(savePaymentSettings({ propertyId, paymentSettings })))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps, { fromDashboard }) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (paymentSettings) =>
    fromDashboard
      ? dispatchProps.onSubmitFromDashboard(paymentSettings)
      : dispatchProps.onSubmit(paymentSettings, stateProps.editMode),
  onClose: () => dispatchProps.onClose(stateProps.editMode),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DueDatePage);
